import { useAsyncDataRequestStatus } from '@/wabunka-src/common/composables';
import { useMicroCMSGetListDetail } from '@/wabunka-src/common/composables/query/useMicroCMSClient';
import type { microCMSDraftKeyQuery } from '@/wabunka-src/common/models/microCMS';
import type { DestinationThemeContentResponse, DestinationThemeContentViewModel } from '@/wabunka-src/features/DestinationTheme/models/destinationThemeContent';
import { createDefaultDestinationThemeContent } from '@/wabunka-src/features/DestinationTheme/models/destinationThemeContent';

import type { AsyncDataRequestStatus } from 'nuxt/app';

/**
 * pathとqueryからdedupe用のkeyの組み立てを行う
 */
const buildKey = (path: string, query?: object, server?: boolean) => {
  return path + (query ? ',query=' + JSON.stringify(query) : '') + (server ? ',server' : ',client');
};

interface UseDestinationThemeContentQueryParams {
  destination: string;
  theme: string;
  draftKey?: microCMSDraftKeyQuery;
  server?: boolean;
}

/**
 * destination-theme content の取得に使用する Composable
 * Page でのみ使用可能
 */
export const useDestinationThemeContentQuery = async ({ destination, theme, draftKey, server = false }: UseDestinationThemeContentQueryParams) => {
  const contentId = `${destination}-${theme}`;
  const filters = 'type[equals]destination-theme';

  const { data, status }: { data: Ref<DestinationThemeContentResponse | null>; status: Ref<AsyncDataRequestStatus> } = await useMicroCMSGetListDetail<DestinationThemeContentResponse>(
    {
      endpoint: 'en-featured',
      contentId,
      queries: { ...draftKey, filters },
    },
    {
      key: buildKey(`en-featured-${contentId}`, { ...draftKey }, server),
      server: server,
    },
  );

  const destinationThemeContent = computed<DestinationThemeContentViewModel>(() => data.value || createDefaultDestinationThemeContent());

  return { destinationThemeContent, ...useAsyncDataRequestStatus(status) };
};
